export default __webpack_public_path__ + "static/media/files-circle-tc.9148928a.svg";